import {
  MdIntegrationInstructions,
  MdManageAccounts,
} from "@onemind-services-llc/react-icons-ng/md";
import { RiVerifiedBadgeFill } from "@onemind-services-llc/react-icons-ng/ri";
import { PiLightningFill } from "@onemind-services-llc/react-icons-ng/pi";

export const OFFERINGS_CONSTANTS = {
  title: "With MOST, you get:",
  list: [
    {
      icon: MdManageAccounts,
      title: "Fully Managed Platform",
      text: "A product-grade OpenStack platform with zero ops overhead",
    },
    {
      icon: PiLightningFill,
      title: "Rapid Provisioning",
      text: "Rapid provisioning of compute, storage, and networking via UI, CLI, or API",
    },
    {
      icon: MdIntegrationInstructions,
      title: "Seamless Integration",
      text: "Support for IaaS, Kubernetes, CI/CD, and hybrid environments",
    },
    {
      icon: RiVerifiedBadgeFill,
      title: "Enterprise Security",
      text: "Built-in security, compliance, and high availability",
    },
    {
      icon: MdManageAccounts,
      title: "Vendor Freedom",
      text: "Open standards and automation-first design",
    },
  ],
};
